import { Html, useProgress } from '@react-three/drei';

export default function Loader() {
    const { active, progress, errors, item, loaded, total } = useProgress();
    return <>
        <color args={ [ '#16192E' ] } attach="background"/>
        <Html center>
            <div >
                {/* <div style={{ width: '100px', height: '10px', backgroundColor: 'gray' }}>
                    <div style={{ width: `${(loaded/total)*100}%`, height: '100%', backgroundColor: 'limegreen' }}></div>
                </div> */}
                <progress className='loaderContainer' max={total} value={loaded}></progress>
            </div>
            <p className="loader-text">{Math.trunc((loaded/total)*100)}%</p>
            {/* <progress max={total} value={loaded}></progress> */}
        </Html>
        </>;
}
